export enum FoSPLogilabSalesStatus {
  OrderCreated = "OrderCreated",
  PendingProcessing = 'PendingProcessing',
  InPreparation = 'InPreparation',
  PendingShipment = 'PendingShipment',
  Shipped = 'Shipped',
  Canceled = 'Canceled'
}
